import * as _ from 'lodash';
import { tassign } from 'tassign';
import { createReducer, on } from '@ngrx/store';
import { DsrPayform } from '@xpo-ltl/sdk-linehaulpayform';
import { PayformState } from '../app.state';
import { resetPayformStateAction, setPayformStateAction, setPayformReadOnlyAction, editPayformActivityAction, editPayformCommentAction, editPayformScheduleAction } from './payform.actions';

export const initialState: PayformState = {
  readOnly: true,
  current: new DsrPayform(),
  pristine: new DsrPayform(),
};

export const PayformReducer = createReducer(
  initialState,
  on(setPayformStateAction, (state, { payform }) => ({
    readOnly: state.readOnly,
    current: _.cloneDeep(payform),
    pristine: _.cloneDeep(payform),
  })),
  on(resetPayformStateAction, state => ({
    readOnly: state.readOnly,
    current: _.cloneDeep(state.pristine),
    pristine: state.pristine,
  })),
  on(setPayformReadOnlyAction, (state, { readOnly }) => tassign(state, { readOnly })),
  on(editPayformActivityAction, (state, { actvtySequenceNbr, activity, schSequenceNbr }) => {
    const current = {
      ..._.cloneDeep(state.current),
      actvtySequenceNbr,
      activity,
      schSequenceNbr,
    };
    return tassign(state, { current });
  }),
  on(editPayformCommentAction, (state, { comment }) => {
    const current = {
      ..._.cloneDeep(state.current),
      comment,
    };
    return tassign(state, { current });
  }),
  on(editPayformScheduleAction, (state, { schedule, schSequenceNbr, patchData }) => {
    const current = {
      ..._.cloneDeep(state.current),
      schedule,
      schSequenceNbr,
      patchData,
    };
    return tassign(state, { current });
  })
);
